import { Baselayer, Ecommerce, Taxonomy, TrackingContract } from '../..';
import snakeCase from 'lodash/snakeCase';

const snakeCaseKeys = <T extends Record<string, unknown>>(obj: T) =>
    Object.entries(obj).reduce<T>(
        (acc, [key, value]) => ({
            ...acc,
            ...{ [snakeCase(key)]: value }
        }),
        {} as T
    );

export const mapTracking = (
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
): TrackingContract | null => {
    if (typeof window === 'undefined' || !window.analytics) {
        return null;
    }

    const baselayer: Baselayer = {
        session_id: window.__global_base_session_id,
        instance_id: window.__global_base_instance_id,
        device_id: window.__global_base_device_id,
        session_count: window.__global_base_session_count
    };

    const eventData: TrackingContract = {
        baselayer,
        ecommerce
    };

    if (taxonomy) {
        eventData.taxonomy = snakeCaseKeys({
            ...taxonomy,
            path: window.location.pathname
        });
    }
    if (ecommerce) {
        eventData.ecommerce = snakeCaseKeys({
            ...ecommerce
        });
    }

    return eventData;
};
